import {
  SASSMALL_AGREEMENT_ACCEPTED_KEY,
  SASSMALL_AUTH_MODE_KEY,
  SASSMALL_CONFIRM_ORDER_KEY,
  SASSMALL_CONFIRM_ORDER_SOURCE_KEY,
  SASSMALL_TENANT_DOMAIN_KEY,
  SASSMALL_TOKEN_KEY,
} from "./constants";

function getStorage() {
  return process.client ? window.localStorage : null;
}

export function getSassmallToken() {
  return String(getStorage()?.getItem(SASSMALL_TOKEN_KEY) || "").trim();
}

export function setSassmallToken(token?: string) {
  const storage = getStorage();
  if (!storage) return;
  const normalized = String(token || "").trim();
  if (normalized) storage.setItem(SASSMALL_TOKEN_KEY, normalized);
  else storage.removeItem(SASSMALL_TOKEN_KEY);
}

export function getSassmallTenantDomain() {
  return String(getStorage()?.getItem(SASSMALL_TENANT_DOMAIN_KEY) || "")
    .trim()
    .toLowerCase();
}

export function setSassmallTenantDomain(domain?: string) {
  const storage = getStorage();
  if (!storage) return;
  const normalized = String(domain || "").trim().toLowerCase();
  if (normalized) storage.setItem(SASSMALL_TENANT_DOMAIN_KEY, normalized);
  else storage.removeItem(SASSMALL_TENANT_DOMAIN_KEY);
}

export function setSassmallAuthMode(mode?: "LOCAL" | "LEGACY") {
  const storage = getStorage();
  if (!storage) return;
  if (mode) storage.setItem(SASSMALL_AUTH_MODE_KEY, mode);
  else storage.removeItem(SASSMALL_AUTH_MODE_KEY);
}

export function getSassmallAgreementAccepted() {
  return getStorage()?.getItem(SASSMALL_AGREEMENT_ACCEPTED_KEY) === "1";
}

export function setSassmallAgreementAccepted(accepted: boolean) {
  const storage = getStorage();
  if (!storage) return;
  if (accepted) storage.setItem(SASSMALL_AGREEMENT_ACCEPTED_KEY, "1");
  else storage.removeItem(SASSMALL_AGREEMENT_ACCEPTED_KEY);
}

export function clearSassmallAuth() {
  const storage = getStorage();
  if (!storage) return;
  storage.removeItem(SASSMALL_TOKEN_KEY);
  storage.removeItem(SASSMALL_AUTH_MODE_KEY);
}

export function getSassmallConfirmOrderDraft<T = Record<string, any>>() {
  const rawValue = getStorage()?.getItem(SASSMALL_CONFIRM_ORDER_KEY);
  if (!rawValue) return null;
  try {
    return JSON.parse(rawValue) as T;
  }
  catch {
    return null;
  }
}

export function setSassmallConfirmOrderDraft(draft: Record<string, any>) {
  const storage = getStorage();
  if (!storage) return;
  storage.setItem(SASSMALL_CONFIRM_ORDER_KEY, JSON.stringify(draft));
  storage.setItem(SASSMALL_CONFIRM_ORDER_SOURCE_KEY, String(draft.mode || ""));
}

export function clearSassmallConfirmOrderDraft() {
  const storage = getStorage();
  if (!storage) return;
  storage.removeItem(SASSMALL_CONFIRM_ORDER_KEY);
  storage.removeItem(SASSMALL_CONFIRM_ORDER_SOURCE_KEY);
}
